import LiquiditySummaryToolbar from 'widgets/liquiditySummary/toolbar/LiquiditySummaryToolbar';
import LiquiditySummaryChartLegends from 'widgets/liquiditySummary/chart/LiquiditySummaryChartLegends';
import React from 'react';
import { BarMouseOver } from 'widgets/liquiditySummary/chart/BarMouseOver';
import { LiquiditySummaryChartData } from 'widgets/liquiditySummary/chart/liquiditySummaryChartData';
import { useLiquiditySummaryChartDimensions } from 'widgets/liquiditySummary/chart/dimensions';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';

export interface LiquiditySummaryChartHeaderProps {
    haveData: boolean;
    mouseOver: BarMouseOver;
    symbol: string;
    isDefault: boolean;
    chartData: LiquiditySummaryChartData;
}

export function LiquiditySummaryChartHeader(
    props: LiquiditySummaryChartHeaderProps
) {
    const { haveData, symbol, chartData, mouseOver, isDefault } = props;
    const { hideLegends } = useLiquiditySummaryChartDimensions();
    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();

    return (
        <WidgetToolbarShowHidePanel
            mustShow={!hasValidSelection || !hideLegends}
        >
            <LiquiditySummaryToolbar haveData={haveData}>
                {!hideLegends && (
                    <LiquiditySummaryChartLegends
                        symbol={symbol}
                        data={chartData}
                        mouseOver={mouseOver}
                        isDefault={isDefault}
                    />
                )}
            </LiquiditySummaryToolbar>
        </WidgetToolbarShowHidePanel>
    );
}
